
export default [

        {
            path:'/jubuDetail',
            name:'jubuDetail',
            component:() => import('@/views/jubuDetail/jubuDetail'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
            }
        },
        
]


// WEBPACK FOOTER //
// ./src/router/jubuDetail.js